module.exports = __webpack_public_path__ + "img/scale-balanced.48661a5a.svg";